//Built-in libraries
//Third party libraries

import { Route, Routes } from 'react-router';
import { CCLFForm } from '@/components/Applications/CCLFForm';
import ClientApplicationChecklist from '@/components/Applications/ClientApplication/ClientApplicationChecklist';
import { HandHousingForm } from '@/components/Applications/HandHousingForm';
import { ApplicationForm } from '@/features/ApplicationForm';
import { ApplicationFormLayout } from '@/features/ApplicationForm/Components/ApplicationFormLayout';

import PageNotFound from '../PageNotFound';
import ApplicationSubmitFail from './ApplicationSubmitFail';
//Custom components
import ApplicationSubmitSuccess from './ApplicationSubmitSuccess';

const Applications = () => {
  return (
    <Routes>
      <Route path='/' element={<ApplicationFormLayout />}>
        <Route
          path='client-application'
          element={
            <ClientApplicationChecklist>
              <CCLFForm />
            </ClientApplicationChecklist>
          }
        />
        <Route path='client-application' element={<HandHousingForm />} />
        <Route path=':applicationFormId'>
          <Route index element={<ApplicationForm />} />
          <Route path='submit_success' element={<ApplicationSubmitSuccess />} />
          <Route path='submit_failed' element={<ApplicationSubmitFail />} />
        </Route>

        <Route path='submit-success' element={<ApplicationSubmitSuccess />} />
        <Route path='submit-failed' element={<ApplicationSubmitFail />} />
        <Route path='*' element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default Applications;
